/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'version': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M959.893 511.632c0-247.404-200.613-448.016-448.016-448.016S63.862 264.228 63.862 511.632s200.612 448.015 448.015 448.015 448.016-200.612 448.016-448.015zm-384.174 205.71c-66.207 70.689-149.834 93.337-159.792 40.074-7.594-40.073 31.985-185.678 39.946-240.435 2.616-17.92-20.033 0-20.033 0s-64.962 45.799-79.899 20.038c-2.363-4.104 13.691-16.675 20.038-20.038 0 0 135.522-99.555 179.83-80.144 44.303 19.412-15.558 142.122-20.038 160.288-4.355 18.17-32.48 157.182 59.981 80.147 0 0 46.172-30.74-20.033 40.07M541.87 376.604c-38.58-2.112-68.077-35.215-65.96-73.797 2.118-38.705 35.093-68.324 73.675-66.206 38.578 2.117 68.072 35.22 65.955 73.798-2.113 38.703-35.092 68.322-73.67 66.205"/>'
  }
})
